import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { AssetColorLabel, AssetDto, AssetStatus, GalleryColorLabel, GalleryDto } from '@nusign/picflow-backend-types';
import { AssetStatusButtonComponent } from '../../../gallery/components/asset-status-button/asset-status-button.component';
import { ColorLabelContextComponent } from '../../../gallery/components/color-label-context/color-label-context.component';
import { ColorLabelColorPipe } from '../../../gallery/pipes/color-label-color.pipe';
import { ContextMenuService } from '../../../services/context-menu.service';
import { PermissionService } from '../../../services/permission.service';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';

@Component({
  selector: 'app-asset-feedback',
  templateUrl: './asset-feedback.component.html',
  styleUrls: ['./asset-feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SvgComponent,
    ButtonDirective,
    ContextMenuComponent,
    AssetStatusButtonComponent,
    ColorLabelContextComponent,
    ColorLabelColorPipe,
    TooltipDirective,
  ],
})
export class AssetFeedbackComponent {
  private permissionService = inject(PermissionService);
  private contextMenuService = inject(ContextMenuService);
  readonly asset = input.required<AssetDto>();
  readonly is_liked = input.required<boolean>();
  readonly status = input.required<AssetStatus>();
  readonly color_label = input.required<AssetColorLabel>();
  readonly gallery = input.required<GalleryDto>();
  readonly galleryPermissions = input.required<GalleryDto['permissions']>();
  readonly clientMode = input.required<boolean>();
  colorLabels = input.required<GalleryColorLabel[]>();

  toggleAssetLike = output<void>();
  updateAssetColorLabel = output<AssetColorLabel>();
  updateAssetStatus = output<AssetStatus>();

  feedbackOptions = computed(() => {
    const gallery = this.gallery();
    const galleryPermissions = this.galleryPermissions();
    if (!gallery || !galleryPermissions) return;
    return this.permissionService.getAllowedAndEnabledFeedbackOptions(
      gallery,
      galleryPermissions.can_review_if_authenticated
    );
  });

  stopPropagation(event: Event) {
    event.preventDefault();
    this.contextMenuService.closeContext();
    event.stopPropagation();
  }
}
